module.exports = __webpack_public_path__ + "img/5.ead66506.png";